import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalState } from '../../state/GlobalStateProvider';
import './Bench.scss';

const Bench = () => {
  const [{ user }] = useGlobalState();
  const history = useNavigate();

  useEffect(() => {
    history(`/profile/${user?.address}/projects`);
  }, []);
  
  return <></>;
};

export default Bench;
